import React, { useEffect, useRef, useState } from "react";
import SchemeCount from "./SchemeCount";
import IrrigatedArea from "./IrrigatedArea";
import Yields from "./Yields";
import IwuaCounCard from "./IwuaCounCard";
import PlannedCard from "./PlannedCard";
import BiomasGraph from "./BiomasGraph";
import HarvestingCard from "./HarvestingCard";
import FarmersGraph from "./FarmersGraph";
import BreadCrumb from "../../layout/BreadCrumb";
import LeafletMap from "./LeafletMap";
import { fetchData } from "../../features/fetch/fetchSlice";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import CardLoading from "../../components/CardLoading";
import { Form, Select } from "antd";

function DashboardMain() {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const { user } = useSelector((state) => state.auth);
  const [active, setActive] = useState("Overview");
  const urlPathway = "api/v2/irrigationPathway/get";
  const handleChange = (value) => {
    setActive(value);
  };
  const [selectId, setSelectId] = useState(null);
  const selectedOrg = localStorage.getItem("selectedOrg");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const url = "api/v2/dashboard/getAllDashboardData";
  const { loading, dataPathway } = useSelector((state) => ({
    loading: state.fetch.loading, 
    dataPathway: state.fetch.data[urlPathway] || [],
  }));

  async function fetchDashData() {
    await dispatch(
      fetchData({
        url: url,
        pathwayId: selectId,
        limit: null,
        start: 0,
      })
    );
  }

  useEffect(() => {
    dispatch(
      fetchData({
        url: urlPathway,
        limit: null,
        start: 0,
      })
    );
  }, []);
  useEffect(() => {
    fetchDashData();
  }, [user, selectId]);
  if (loading) return <CardLoading />;
  return (
    <>
      <div className="flex lg:flex-row flex-col lg:items-center lg:justify-between gap-[.75rem]">
        <Form
          layout="vertical"
          ref={formRef}
          name="control-ref"
          className="lg:w-[20%] w-full"
          form={form}
        >
          <div className="w-full banner-select flex items-center gap-x-[.5rem] text-[#6B7280] text-[.875rem] font-[400] font-interSans">
            <span className="">Pathway</span>
            <Select
              className="banner-selector "
              allowClear
              style={{
                width: "100%",
              }}
              options={
                dataPathway?.length > 0 &&
                dataPathway?.map((item) => ({
                  value: item?.irrigationPathwayId,
                  label: item?.irrigationPathwayName,
                }))
              }
              value={selectId}
              onChange={(value) => setSelectId(value)}
              placeholder="Select"
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.label?.toLocaleLowerCase() ?? "").includes(
                  input?.toLocaleLowerCase()
                )
              }
            />
          </div>
        </Form>
        <div className="border border-[#D6E1F5] rounded-[1.5rem] p-[.5rem] bg-white flex items-center gap-x-[.5rem] w-auto">
          <button
            onClick={() => handleChange("Overview")}
            className={`py-[0.375rem] px-[.75rem] rounded-[1.5625rem] text-[.75rem] font-[400] font-interSans  ${
              active === "Overview"
                ? "text-white bg-darkBlue"
                : "text-[#424242] bg-white"
            }`}
          >
            Overview
          </button>
          <button
            onClick={() => handleChange("Map")}
            className={`py-[0.375rem] px-[.75rem] rounded-[1.5625rem] text-[.75rem] font-[400] font-interSans  ${
              active === "Map"
                ? "text-white bg-darkBlue"
                : "text-[#424242] bg-white"
            }`}
          >
            Map Analysis
          </button>
        </div>
      </div>
      {active === "Overview" ? (
        <>
          {" "}
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-[1.25rem] w-full mt-[1.25rem]">
            <SchemeCount />
            <IrrigatedArea />
            <Yields />
          </div>
          <div className="flex lg:flex-row flex-col items-center  mt-[1.25rem]">
            <PlannedCard />
          </div>
          {user?.userInstitution === "CIDU" || selectedOrg === "NIA" ? null : (
            <div className="flex lg:flex-row flex-col gap-[1.25rem] items-center mt-[1.25rem]">
              {/* <FarmersGraph /> */}
              <BiomasGraph />
            </div>
          )}
          <div className="grid sm:grid-cols-1 lg:grid-cols-2 gap-[1.25rem] w-full  mt-[1.25rem]">
            {user?.userInstitution === "CIDU" ? null : <HarvestingCard />}
            <IwuaCounCard />
          </div>
        </>
      ) : (
        <LeafletMap />
      )}
    </>
  );
}

export default DashboardMain;
